import React from 'react';
import './loan-step.css';
import './RequiredDocuments.css';
import {
  ScrollReveal,
  ScrollRevealStagger,
  ScrollRevealItem,
} from './ScrollReveal';

const journeySteps = [
  {
    id: '01',
    color: '#0F8F5E',
    title: 'Identity Proof (KYC)',
    desc: 'Aadhaar, PAN, or Passport for instant digital profile verification.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden="true">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    ),
  },
  {
    id: '02',
    color: '#10273F',
    title: 'Address Verification',
    desc: 'Utility bills, Voter ID, or rental agreement for your location.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden="true">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        <polyline points="9 22 9 12 15 12 15 22" />
      </svg>
    ),
  },
  {
    id: '03',
    color: '#0c7350',
    title: 'Income Validation',
    desc: 'Salary slips for 3 months or business turnover proof sheets.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden="true">
        <line x1="12" y1="1" x2="12" y2="23" />
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
      </svg>
    ),
  },
  {
    id: '04',
    color: '#1a3d5c',
    title: 'Bank Statements',
    desc: 'Last 6 months showing clear salary or income credits.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden="true">
        <rect x="2" y="7" width="20" height="14" rx="2" />
        <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
      </svg>
    ),
  },
  {
    id: '05',
    color: '#C99A3F',
    iconLight: true,
    title: 'Employment & Photo',
    desc: 'Employee ID or work email plus recent passport-size photograph.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden="true">
        <circle cx="12" cy="12" r="10" />
        <circle cx="12" cy="10" r="3" />
        <path d="M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662" />
      </svg>
    ),
  },
];

function ChevronFrame({ color }) {
  return (
    <svg
      className="rj-chevron-svg"
      viewBox="0 0 200 100"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <path
        d="M48 4 H175 L200 50 L175 96 H8"
        fill="none"
        stroke={color}
        strokeWidth="4.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const RequiredDocuments = () => {
  return (
    <section className="rj-section" id="required-documents" aria-labelledby="rj-title">
      <div className="lifecycle-bg-orb-one" aria-hidden="true" />
      <div className="lifecycle-bg-orb-two" aria-hidden="true" />
      <div className="lifecycle-dotted-grid" aria-hidden="true" />

      <div className="rj-container">
        <ScrollReveal as="header" className="rj-header" y={32}>
          <h2 id="rj-title" className="rj-title">
            Required <span className="rj-title-accent">Documents</span>
          </h2>
          <p className="rj-subtitle">
            Key documents needed for a smooth, paperless loan application.
          </p>
        </ScrollReveal>

        <ScrollReveal className="rj-board" delay={0.1} y={36}>
          <ScrollRevealStagger className="rj-steps" stagger={0.11}>
            {journeySteps.map((step) => (
              <ScrollRevealItem
                key={step.id}
                as="article"
                className="rj-step"
                style={{ '--rj-color': step.color }}
                y={32}
              >
                <div className="rj-step-body">
                  <div
                    className={`rj-icon${step.iconLight ? ' rj-icon--light' : ''}`}
                    style={{ backgroundColor: step.color }}
                  >
                    {step.icon}
                  </div>

                  <div className="rj-frame-wrap">
                    <ChevronFrame color={step.color} />
                    <div className="rj-copy">
                      <h3>{step.title}</h3>
                      <p>{step.desc}</p>
                    </div>
                  </div>
                </div>

                <div className="rj-connector" aria-hidden="true">
                  <span className="rj-dash" />
                  <span className="rj-node" />
                </div>
              </ScrollRevealItem>
            ))}
          </ScrollRevealStagger>

          <div className="rj-rail" aria-hidden="true" />
        </ScrollReveal>
      </div>
    </section>
  );
};

export default RequiredDocuments;
